/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProjectFreelancerExternalReferenceRequest
 */
export interface UpdateProjectFreelancerExternalReferenceRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProjectFreelancerExternalReferenceRequest
     */
    reference: string;
}

/**
 * Check if a given object implements the UpdateProjectFreelancerExternalReferenceRequest interface.
 */
export function instanceOfUpdateProjectFreelancerExternalReferenceRequest(value: object): value is UpdateProjectFreelancerExternalReferenceRequest {
    if (!('reference' in value) || value['reference'] === undefined) return false;
    return true;
}

export function UpdateProjectFreelancerExternalReferenceRequestFromJSON(json: any): UpdateProjectFreelancerExternalReferenceRequest {
    return UpdateProjectFreelancerExternalReferenceRequestFromJSONTyped(json, false);
}

export function UpdateProjectFreelancerExternalReferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProjectFreelancerExternalReferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reference': json['reference'],
    };
}

export function UpdateProjectFreelancerExternalReferenceRequestToJSON(value?: UpdateProjectFreelancerExternalReferenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reference': value['reference'],
    };
}

